import { render, staticRenderFns } from "./RmpBottomSpace.vue?vue&type=template&id=2413b942"
import script from "./RmpBottomSpace.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpBottomSpace.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports